module.exports = __webpack_public_path__ + "static/foot-ankle-7b3d229344e3ece91a3169fc511048ac.jpg";